import {Component, Input, OnInit, Output, ViewChild, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import {IonContent} from '@ionic/angular';

@Component({
    selector: 'app-accent-button',
    templateUrl: './accent-button.component.html',
    styleUrls: ['./accent-button.component.css'],
})
export class AccentButtonComponent implements OnInit {

    @Input() position = 'left';
    @Input() buttonClass = 'bg-mustard-500';

    @Input() href;
    @Input() external = false;

    @Input() scrollToTop = false;
    @ViewChild(IonContent) content;

    @Output() click = new EventEmitter();

    constructor(private router: Router) {
    }

    ngOnInit() {
    }

    onClick() {
        if (this.scrollToTop) {
            window.document.querySelector('.main-header').scrollIntoView();

            requestAnimationFrame(() => {
                window.document.querySelector('.main-header').scrollIntoView();
            });

            this.content.scrollToBottom();

            return;
        }
        if (this.href) {
            if (this.external) {
                window.open(this.href, '_blank');
                return;
            }

            this.router.navigate([this.href]);
        }

        this.click.emit();
    }

}
